var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-with-link"},[_c('h2',[_vm._v(_vm._s(_vm.text))]),_c('link-info',{staticClass:"u-color--blue",attrs:{"nameLink":_vm.nameLink,"href":_vm.href}},[_vm._v(_vm._s(_vm.nameLink))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }